import { takeLatest, put } from "redux-saga/effects";
import { AD_TRACK_REQUEST, AD_TRACK_SUCCESS, AD_TRACK_FAIL } from "../actions/ActionConstant";
import api from "../../Environment";

function* trackAdSaga(action) {
    try {
        const inputData = action.payload;

        const response = yield api.postMethod("ad_track", inputData);

        if (response.data.success) {
            yield put({
                type: AD_TRACK_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({ type: AD_TRACK_FAIL });
        }
    } catch (error) {
        yield put({ type: AD_TRACK_FAIL });
    }
}

export default function* AdSaga() {
    yield takeLatest(AD_TRACK_REQUEST, trackAdSaga);
}